import { icons } from "@pickit/pickit-components/dist/StaticIcon/icons";
import { CountryCodeType } from "reducers/types/session";
import { QueryParamsType } from "./types";

export const endsWithAny = (phrase: string, words: string[]) => {
  return words.some((word: string) => {
    return phrase.endsWith(word);
  });
};

export const saveValue = (key: string, value: object | string) => {
  if (typeof value === "object") {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
};

export const saveSessionValue = (key: string, value: object | string) => {
  if (typeof value === "object") {
    sessionStorage.setItem(key, JSON.stringify(value));
  } else {
    sessionStorage.setItem(key, value);
  }
};

export const getValue = (key: string, shouldParse?: boolean) => {
  const item = localStorage.getItem(key);
  if (shouldParse) {
    return typeof item === "string" ? JSON.parse(item) : {};
  }
  return item;
};

export const getSessionValue = (key: string, shouldParse?: boolean) => {
  const item = sessionStorage.getItem(key);

  if (shouldParse) {
    return typeof item === "string" ? JSON.parse(item) : {};
  }
  return item;
};

export const removeItem = (key: string) => localStorage.removeItem(key);
export const removeSessionItem = (key: string) =>
  sessionStorage.removeItem(key);

export function parseQueryParams(query: string): QueryParamsType {
  let queryParams: QueryParamsType = {};
  if (query) {
    const queryArray = query.split("?")[1].split("&");
    for (let i = 0; i < queryArray.length; i++) {
      const [key, val] = queryArray[i].split("=");
      queryParams[key as string] = val ? val : true;
    }
  }
  return queryParams;
}

export const getFlag = (countryCode: CountryCodeType) => {
  if (!countryCode) return "" as keyof typeof icons;
  return `flag-${countryCode?.toLowerCase()}` as keyof typeof icons;
};
